import {NewsResponsePayload} from '../../../models/api';

export default [
  {
    id: 134,
    name: '1 - Жители Ревды могут оформить ЕСК в своем городе',
    image: 'https://st.eskmo.ru/uploads/Ap/ZU/jk7ps8Jo_faRfnCVi1kECG2H5SPw.jpg',
    description:
      '<p>текст <strong>жирный</strong> <i>курсив</i> <span class="text-big">А+</span> <span class="text-tiny">А-</span> <a href="google.com">ссылка</a>&nbsp;</p><ul><li>список1</li><li>список2</li></ul><ol><li>номер1</li><li>номер2</li></ol><blockquote><p>цитата</p></blockquote><p><span style="color:#00965A;">зеленый</span></p><p><span style="color:#EF7D01;">почти красный</span></p><h2>заголовок2</h2><h3>заголовок3</h3>',
    status: 1,
    category: 7,
    createdAt: '08.12.2020',
  },
  {
    id: 133,
    name: '2 - Единая социальная карта теперь выручает в «Пятёрочке»',
    image: 'https://st.eskmo.ru/uploads/0W/gi/9f6NE8PSIxEaNssmj1Fj0IayVv_n.jpg',
    description:
      '<p>Крупнейшая торговая сеть «Пятёрочка» присоединилась к проекту «Единая социальная карта Свердловской области» интегрировав свою программу лояльности в ЕСК. Начиная с 5 декабря достаточно будет предъявить свою ЕСК на кассе в любой "Пятёрочке", чтобы воспользоваться бонусами, скидками и специальными предложениями&amp;nbsp;<a href="https://5ka.ru/card/">программы лояльности</a> «Выручай-карта».</p>',
    status: 1,
    category: 7,
    createdAt: '04.12.2020',
  },

  {
    id: 132,
    name: '3 - Региональные льготы теперь будут перечисляться на Единую социальную карту ',
    image: 'https://st.eskmo.ru/uploads/L2/hT/pB3lgQxKQ7VqpqgSJ2JRKEj4YQOG.jpg',
    description:
      '<p>С 1 января 2021 года в Свердловской области начнет действовать новый порядок выплат денежных компенсаций и пособий. Все региональные социальные выплаты свердловчане смогут получать на Единую социальную карту Свердловской области. В случае ее отсутствия средства можно будет получить в почтовом отделении по месту жительства.</p>',
    status: 1,
    category: 7,
    createdAt: '01.12.2020',
  },

  {
    id: 131,
    name: '4 - За ЕСК - в новый пункт выдачи!',
    image: 'https://st.eskmo.ru/uploads/Il/Ab/bq7NV0FiGMnziUmOxXJB3GbeDaEU.jpg',
    description:
      '<p>Оформить нефинансовую Единую социальную карту теперь можно в еще одном пункте выдачи в Екатеринбурге - на улице Свердлова, 22 (офис 1).</p>',
    status: 1,
    category: 7,
    createdAt: '20.11.2020',
  },

  {
    id: 130,
    name: '5 - В офисах МФЦ начали выдачу Единой социальной карты  ',
    image: 'https://st.eskmo.ru/uploads/Nf/em/7BQ3Sne8SZ-uor2W0ML19yjn28fs.jpeg',
    description:
      '<p>Получить Единую социальную карту от СКБ-банка теперь можно в офисах Многофункциональных центров Свердловской области. Ранее оформить банковскую соцкарту свердловчане могли только в офисах банка-партнера.&amp;nbsp;</p>',
    status: 1,
    category: 7,
    createdAt: '02.11.2020',
  },

  {
    id: 129,
    name: '6 - Оформи Единую социальную карту и выиграй умную колонку',
    image: 'https://st.eskmo.ru/uploads/CX/hb/85gTyE2VPCAQSCnKOx7m4-Zi1td_.jpg',
    description:
      '<p>Свердловчане, оформившие Единую социальную карту, могут выиграть умную колонку и другие полезные гаджеты. Для того, чтобы побороться за ценные призы, достаточно оформить ЕСК до 15 декабря 2020 года – новые держатели автоматически становятся участниками розыгрыша.</p>',
    status: 1,
    category: 7,
    createdAt: '19.10.2020',
  },

  {
    id: 127,
    name: '7 - Кэшбэк 10% за покупки в интернет-магазине ESTEL вместе с ЕСК',
    image: 'https://st.eskmo.ru/uploads/Ek/LF/yXwxW59pvQeZhPEw9y54U-7lHNaK.png',
    description:
      '<p>Новая акция для держателей Единой социальной карты от платежной системы "Мир" и интернет-магазина профессиональной косметики ESTEL - кэшбэк 10% за любую покупку на сайте estelstore.pro.&amp;nbsp;</p>',
    status: 1,
    category: 7,
    createdAt: '08.10.2020',
  },

  {
    id: 128,
    name: '8 - В Сысерти заработала Единая социальная карта',
    image: 'https://st.eskmo.ru/uploads/i9/WN/4m-Yx0rQOhPATYv5StKY8iqRAHMj.jpg',
    description:
      '<p>Заменить многочисленные пластиковые карты одной-единственной теперь можно и в Сысерти. В отделении местного фонда поддержки предпринимательства заработал пункт выдачи удобного электронного носителя, выпущенного по указу губернатора Свердловской области. К слову,&amp;nbsp;Единую социальную карту с банковским приложением жители города оформляют в отделении «СКБ-банка» уже с августа.</p>',
    status: 1,
    category: 7,
    createdAt: '07.10.2020',
  },

  // {
  //   id: 126,
  //   name: 'Переход на карты "Мир" откладывается до конца года',
  //   image: 'https://st.eskmo.ru/uploads/yL/Ea/v_DYmNLIfVrF4X_BtMnFfOz4B_FK.jpg',
  //   description:
  //     '<p>Пенсионеров и получателей социальных пособий постепенно переводят на карты "Мир". <span style="color:rgb(0,0,0);">С 1 января следующего года отдельные соцвыплаты будут перечисляться исключительно на банковские карты национальной платежной системы.</span></p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '06.10.2020',
  // },

  // {
  //   id: 125,
  //   name: 'Теперь -3% на товары марки "Молочный кит"',
  //   image: 'https://st.eskmo.ru/uploads/-w/l0/71TjoXIbWlDmXqWgYk0H-l8Y57WY.png',
  //   description:
  //     '<p><span style="color:rgb(0,0,0);">Наш партнер </span><a href="https://eskmo.ru/holder/capabilities/partner/689"><span style="color:rgb(0,0,0);">"Молочный кит"</span></a><span style="color:rgb(0,0,0);">, один из ведущих молочных производителей Уральского региона, изменил скидку для держателей Единой социальной карты до 3%!</span></p>',
  //   status: 1,
  //   category: 1,
  //   createdAt: '05.10.2020',
  // },

  // {
  //   id: 124,
  //   name: 'Будь уверен в завтрашнем дне вместе с ЕСК',
  //   image: 'https://st.eskmo.ru/uploads/WS/QO/YQFpHspfFjvPEkb5mXASYdm0eEFl.jpg',
  //   description:
  //     '<p><span style="color:rgb(0,0,0);">Выбрать страховую компанию - это выбрать уверенность в завтрашнем дне. Ведь страховка должна выручить вас в трудные минуты жизни основывается на принципах открытости и максимального внимания к потребностям каждого.</span></p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '01.10.2020',
  // },

  // {
  //   id: 123,
  //   name: 'Клубная карта Сима-Ленд уже есть у держателей ЕСК',
  //   image: 'https://st.eskmo.ru/uploads/7l/Ut/C9KFXv6Ue300faCIKfPpA-GOow9s.jpg',
  //   description:
  //     '<p>Теперь Единая социальная карта Свердловской области работает как клубная карта гипермаркета “Сима-Ленд”!</p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '11.09.2020',
  // },

  // {
  //   id: 122,
  //   name: '"Сборная выгодных предложений": болейте за Россию и получайте выгодные предложения каждый день!',
  //   image: 'https://st.eskmo.ru/uploads/O6/uz/fQMg7GxOlCuNDVCMwVJF3KRXcbo2.jpg',
  //   description:
  //     '<p><span style="color:rgb(0,0,0);">Отличная новость для держателей банковской Единой социальной карты - выгодные предложения к открытию футбольного сезона от платежной системы "Мир" и Сборной России по футболу!</span></p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '09.09.2020',
  // },

  // {
  //   id: 121,
  //   name: 'Выходные в Меге вместе с ЕСК',
  //   image: 'https://st.eskmo.ru/uploads/PG/VC/neVo7ETMN-2cj12oP-RejPZBQ7Ap.jpg',
  //   description:
  //     '<p>В минувшие выходные посетители Меги-Екатеринбург смогли познакомиться с Единой социальной картой лично.&amp;nbsp;</p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '31.08.2020',
  // },

  // {
  //   id: 114,
  //   name: 'Илья Крупин посетил CorpSpace-20/08',
  //   image: 'https://st.eskmo.ru/uploads/zJ/EF/v51pTtMLRbQ1Su3TlBHy8IlGMZNU.jpg',
  //   description:
  //     '<p>Заместитель генерального директора ООО «Сапфир-Эксперт» Илья Викторович Крупин посетил форум CorpSpace-20/08, который состоялся в минувший четверг на площадке «Точки кипения» в Ельцин-Центре.&amp;nbsp;</p>',
  //   status: 1,
  //   category: 6,
  //   createdAt: '24.08.2020',
  // },

  // {
  //   id: 115,
  //   name: '"Астра - Девелопмент" — новый партнер Единой социальной карты',
  //   image: 'https://st.eskmo.ru/uploads/Bk/qm/zS-nTG2Zq_N2_ZQb67c2uBOoV4zx.png',
  //   description:
  //     '<p><span style="color:rgb(0,0,0);">При покупке квартиры мы всегда выбираем проверенного застройщика с отличной репутацией. Так и Единая социальная карта выбирает сильных партнеров из разных сфер. Одна из таких компаний </span><span style="color:rgb(77,81,86);">—</span><span style="color:rgb(0,0,0);"> "Астра - Девелопмент", ведущая строительная компания.</span></p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '20.08.2020',
  // },

  // {
  //   id: 113,
  //   name: 'Алексей Орлов оформил Единую социальную карту в числе первых',
  //   image: 'https://st.eskmo.ru/uploads/TF/Da/PQbHfeixQQqWb63w8LIiSFhlxjHf.jpg',
  //   description:
  //     '<p>Исполняющий обязанности губернатора Свердловской области Алексей Орлов проверил ход реализации проекта «Единая социальная карта Свердловской области». Сегодня он посетил один из пунктов выдачи и пообщался с потенциальными держателями карты.&amp;nbsp;</p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '19.08.2020',
  // },

  // {
  //   id: 112,
  //   name: 'Свердловчане получили первые Единые социальные карты',
  //   image: 'https://st.eskmo.ru/uploads/Pi/PD/hHPoT3fY8PS7ltNGkvkytaaezg0N.jpg',
  //   description:
  //     '<p>Жители Свердловской области теперь могут получить Единую социальную карту. Она заменит сразу несколько пластиковых карт. Свои первые ЕСК свердловчане получили уже сегодня.</p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '17.08.2020',
  // },

  // {
  //   id: 111,
  //   name: 'Единая социальная карта Свердловской области станет доступна с 17 августа',
  //   image: 'https://st.eskmo.ru/uploads/9z/-k/gllanwVPqpmIOlJ2_WTwCXAcjDhK.jpg',
  //   description:
  //     '<p>С 17 августа жители Свердловской области смогут получать Единую социальную карту региона с социальными приложениями. Об этом заявил исполняющий обязанности губернатора Свердловской области <strong>Алексей Орлов</strong> на заседании межведомственной рабочей группы по реализации проекта.</p>',
  //   status: 1,
  //   category: 7,
  //   createdAt: '14.08.2020',
  // },

  // {
  //   id: 110,
  //   name: '"Сапфир-Эксперт" возглавил Павел Ведерников',
  //   image: 'https://st.eskmo.ru/uploads/lD/ym/puSnrm1IkTMVd-C0q1GsxOTo9ElD.jpg',
  //   description:
  //     '<p>Новый руководитель был представлен коллективу компании и уже приступил к исполнению служебных обязанностей. До этого Павел Юрьевич более 10 лет руководил проектом «ЕКАРТА» (АО «И-сеть») - системой безналичной оплаты в общественном транспорте Екатеринбурга, Верхней Пышмы, Ревды и Среднеуральска.</p>',
  //   status: 1,
  //   category: 6,
  //   createdAt: '10.07.2020',
  // },
] as NewsResponsePayload[];
